<template>
  <div class="mpp-panel">
    <div class="mpp-header">
      <button class="mpp-back" type="button" @click="$emit('back')">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
        Voltar
      </button>
      <h2 class="mpp-title">{{ project.name }}</h2>
    </div>

    <div class="mpp-tabs">
      <button class="mpp-tab" :class="{ active: activeTab === 'os' }" type="button" @click="activeTab = 'os'">Ordens de Serviço</button>
      <button class="mpp-tab" :class="{ active: activeTab === 'realizadas' }" type="button" @click="activeTab = 'realizadas'">OS realizadas</button>
    </div>

    <div class="mpp-body">
      <MaintenanceOSTiposTab
        v-if="activeTab === 'os'"
        :project="project"
        :access-level="accessLevel"
      />
      <MaintenanceOSRealizadasTab
        v-else
        :project="project"
        :access-level="accessLevel"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, type PropType } from 'vue'
import type { Project } from '@/store/projects'
import MaintenanceOSTiposTab from './MaintenanceOSTiposTab.vue'
import MaintenanceOSRealizadasTab from './MaintenanceOSRealizadasTab.vue'

export default defineComponent({
  name: 'MaintenanceProjectPanel',
  components: { MaintenanceOSTiposTab, MaintenanceOSRealizadasTab },
  props: {
    project: { type: Object as PropType<Project>, required: true },
    isAdmin: { type: Boolean, default: false },
    accessLevel: { type: Number, default: 0 }
  },
  emits: ['back'],
  setup() {
    const activeTab = ref<'os' | 'realizadas'>('os')
    return { activeTab }
  }
})
</script>

<style scoped lang="scss">
.mpp-panel {
  width: 100%; height: 100%;
  background: var(--bg, #f7f4ee);
  display: flex; flex-direction: column; overflow: hidden;
}

.mpp-header {
  display: flex; align-items: center; gap: 12px;
  padding: 18px 22px 14px;
  border-bottom: 1px solid rgba(31,30,26,.1);
  background: var(--card, #fff);
}

.mpp-back {
  display: flex; align-items: center; gap: 4px;
  background: none; border: none; color: var(--ink-muted); font-size: 13px; cursor: pointer;
  padding: 4px 6px; border-radius: 4px;
  align-self: flex-start;
  &:hover { background: rgba(0,0,0,.05); }
}

.mpp-title { font-size: 16px; font-weight: 700; color: var(--ink); margin: 0; flex: 1; }

.mpp-tabs {
  display: flex; gap: 4px; padding: 12px 22px 0;
  background: var(--card, #fff); border-bottom: 1px solid rgba(31,30,26,.1);
}
.mpp-tab {
  padding: 8px 16px; border: none; background: none;
  font-size: 13px; font-weight: 600; color: var(--ink-muted); cursor: pointer;
  border-bottom: 2px solid transparent; margin-bottom: -1px;
  transition: color .12s, border-color .12s;
  &.active { color: var(--accent); border-bottom-color: var(--accent); }
}

.mpp-body { flex: 1; overflow-y: auto; padding: 20px 22px; }
</style>
